





































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceInsightsDashboardHeader'

  resources:
    audience_listings:
      resourceName: 'audience_listings'
      slug: 'audience_listings'
      params:
        quick_list: true
        limit: 1000
        scope: 'not_omnichannel'
      fetch: false
    audience_creatives:
      resourceName: 'audience_creatives'
      slug: 'audience_creatives'
      params:
        quick_list: true
        limit: 1000
      fetch: false

  vue:
    props: ['organizer', 'options']

    data: ->
      showFilter: false
      target: null

    computed:
      dashboard: ->
        @options?.dashboard

      optionsForAudienceCreatives: ->
        for creative in @audience_creatives || []
          id: creative.id
          label: creative.title

      optionsForAudienceListings: ->
        for listing in @audience_listings || []
          if @target?.scope?.audience_creative_ids?.length > 0
            continue unless listing.creative_id in @target.scope.audience_creative_ids

          title = listing.formatted_title
          location = @$options.filters.formatLocation(listing)

          id: listing.id
          label: if location then "#{title} (#{location})" else title
          title: title
          location: location

    mounted: ->
      @target = @initialTarget()
      @applyFilter()

      # fetch resources after fetching the dashboard not to block the initial render
      @fetch 'audience_listings' unless @audience_listings
      @fetch 'audience_creatives' unless @audience_creatives

    methods:
      applyFilter: ->
        @$emit 'applyFilter', { target: { ...@target } }

      initialTarget: ->
        scope:
          audience_creative_ids: []
          audience_listing_ids: []

      hiToggleFilter: ->
        @showFilter = !@showFilter

      hiApplyFilter: ->
        @applyFilter()

      hiResetFilter: ->
        @target = @initialTarget()
        @applyFilter()

      hiAudienceCreativesChanged: ->
        selectedAudienceListingIds = @pluck(@optionsForAudienceListings, 'id')
        @target.scope.audience_listing_ids = @target.scope.audience_listing_ids.filter((id) => id in selectedAudienceListingIds)

export default VueOptions.vue settings
